import {
  ModalContent as ModalContentPrimitive,
  type ModalContentProps
} from '@chakra-ui/react';
import { ReactNode } from 'react';

export function ModalContent({
  children,
  ...props
}: ModalContentProps): ReactNode {
  return (
    <ModalContentPrimitive borderRadius="radii.x4" {...props}>
      {children}
    </ModalContentPrimitive>
  );
}
